import { render, staticRenderFns } from "./cert.vue?vue&type=template&id=1bfc98ae&scoped=true"
import script from "./cert.vue?vue&type=script&lang=js"
export * from "./cert.vue?vue&type=script&lang=js"
import style0 from "./cert.vue?vue&type=style&index=0&id=1bfc98ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfc98ae",
  null
  
)

export default component.exports